import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderService } from './header.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { ProfileSearchResult } from '../data/ProfileSearchResult';
import { ShipUser } from '../ShipUser';

export interface UserRole {
  roleId: string;
  name: string;
  description: string;
}

@Injectable({
  providedIn: 'root'
})
export class ShipUserService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private headerService: HeaderService
  ) {}

  getShipUserRoles(): Observable<UserRole[]> {
    const url = `${environment.rootApiUrl}/shipUsers/roles`;

    return this.http.get<UserRole[]>(url, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }

  searchByCardPan(firstParameter: string): Observable<ProfileSearchResult[]> {
    const url = `${environment.rootApiUrl}/shipUsers/search`;
    let params = new HttpParams();
    params = params.append('firstParameter', firstParameter || '');

    return this.http.post<ProfileSearchResult[]>(url, params, {
      headers: this.headerService.getXAuthHeaderFromCookie()
    });
  }

  getUserByCardPan(cardPan: number) {
    const url = `${environment.rootApiUrl}/shipUsers/getUserByCardPan/${cardPan}`;

    return this.http.get<ShipUser>(url, {
      headers: this.headerService.getXAuthHeaderFromCookie()
    });
  }

  createOrUpdateShipUser(shipUser: ShipUser) {
    const url = `${environment.rootApiUrl}/shipUsers/createOrUpdateShipUser`;
    let headers = this.headerService.getXAuthHeaderFromCookie();
    headers = headers.set('Content-Type', 'application/json');

    return this.http.post<ShipUser>(url, shipUser, {headers: headers});
  }
}
